// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import type { JSX } from 'react';

interface CredentialSubmittedModalProps {
  opened: boolean;
  onFinish: () => void;
  onEdit: () => void;
}

export function CredentialSubmittedModal({ opened, onFinish, onEdit }: CredentialSubmittedModalProps): JSX.Element {
  return (
    <Modal opened={opened} onClose={onFinish} withCloseButton={false} size="xl" radius="lg">
      <Stack gap={0} m="lg" align="center">
        <Title order={2} ta="center" mb="lg">
          New Credential Submitted
        </Title>
        <Box bg="gray.0" p="xl" style={{ borderRadius: 8, width: '100%' }}>
          <Stack align="center" gap="md">
            <Text fw={700} fz={24} lh="32px" ta="center">
              Your new credential is under review.
            </Text>
            <Text fz={14} ta="center" maw={604}>
              Once your credential has been validated, you will receive a notification that you may now schedule
              appointments with patients covered by the appropriate payor.
            </Text>
            <Group justify="center" gap={10} mt="xs">
              <Button variant="outline" color="polaris" h={50} fz={18} fw={600} onClick={onEdit}>
                Edit My Submission
              </Button>
              <Button color="polaris" h={50} fz={18} fw={600} onClick={onFinish}>
                Finish
              </Button>
            </Group>
          </Stack>
        </Box>
      </Stack>
    </Modal>
  );
}
